import { UserManagerSettings } from 'oidc-client-ts';

// Param used to fill keycloak login based on query param
const urlParams = new URLSearchParams(window.location.search);
const loginHint = urlParams.get('login_hint');

export const oidcConfig: UserManagerSettings = {
  redirect_uri: import.meta.env.VITE_BASE_URL + '/callback',
  post_logout_redirect_uri: import.meta.env.VITE_BASE_URL,
  authority: import.meta.env.VITE_OIDC_ISSUER_URI,
  client_id: import.meta.env.VITE_OIDC_CLIENT_ID,
  scope: 'openid',
  automaticSilentRenew: true,
  response_type: 'code',
  extraQueryParams: {
    login_hint: loginHint ?? '',
  },
};
